import React, { Component } from 'react';
import { Navigation } from '../../navigation/react-redux-nav';
import './index.css';

class LoginButton extends Component {
  render() {
    return (
      <div className="login-button-component">
        <Navigation.JumpTo page="login">
          <button className="login-button">
            <span>Log in</span>
          </button>
        </Navigation.JumpTo>
      </div>
    );
  }
}

export default LoginButton;
